<template>
    <div style="height:100%">

        <div class="mydb-filter" v-click-outside="cancelAppliedFilters">
            <div class="mydb-filter__arrow-up"></div>

            <div class="mydb-filter__header">
                <h4>Filters</h4>
            </div>
            <div class="mydb-filter__body">
                <!-- Candidates -->
                <div v-if="QuestionCategoryList && QuestionCategoryList.length > 0">
                    <div class="fdnsfilter--section" >
                        <p>Question Category</p>
                        <div class="form-group">
                            <div class="checkbox-inline p0" v-for="(c, index) in QuestionCategoryList" :key="index">
                                <ob-checkbox :val="c" v-model="QuestionCategory">{{c}}</ob-checkbox>
                            </div>

                            <!-- <div class="checkbox-inline question-category-padd m0"> -->
                        </div>
                    </div>
                    <div style="clear:both;"></div>
                </div>
                <!--// Question Category -->
                 <!-- <div>
                    <div class="fdnsfilter--section" >
                            <p>Question Mode</p>
                            <div class="form-group">
                                <div class="checkbox-inline p0">
                                    <ob-checkbox val="Automatic" v-model="QuestionMode">Automatic</ob-checkbox>
                                </div>
                                <div class="checkbox-inline question-category-padd m0">
                                    <ob-checkbox val="Manual" v-model="QuestionMode">Manual</ob-checkbox>
                                </div>                              
                            </div>
                    </div>
                    <div style="clear:both;"></div>
                </div> -->
                <!-- // Question Mode -->

            </div>
            <div class="row mydb-filter__footer">
                <ob-button type="secondary" @click="cancelAppliedFilters">Cancel</ob-button>
                <ob-button type="primary" @click="onApply">Apply</ob-button>

            </div>
        </div>

    </div>
</template>
<script>
export default {
    data(){
        return{
            QuestionCategory: [],
            QuestionMode: []
        }
    },
    computed: {
        QuestionCategoryList() {
            return this.$store.getters.getFDNSAllQuestionCategoryList
        },
    },
    created() {
        this.updateSearchFilterFromStore()
    },
    methods:{
        cancelAppliedFilters() {
            this.$emit('cancel')
        },
        onApply() {
            this.updateSearchFilterToStore()
            this.$emit('apply')
        },
        updateSearchFilterFromStore() {
            this.QuestionCategory = this.$store.getters.getFDNSSearchFilterField('QuestionCategory')
            this.QuestionMode = this.$store.getters.getFDNSSearchFilterField('QuestionMode')
        },
        updateSearchFilterToStore() {
            this.$store.commit('updateFDNSSearchFilterField', { field: 'QuestionCategory', value: this.QuestionCategory })
            this.$store.commit('updateFDNSSearchFilterField', { field: 'QuestionMode', value: this.QuestionMode })
        },

    }
}
</script>

<style lang="scss" scoped>
    @import "~styles/framework/bootstrap/variables";

    .mydb-filter {
        background: $ob-white-color;
        width: 600px;
        position: relative;
        border: 1px solid $ob-light-gray-1;
        border-radius: 4px;
        -webkit-box-shadow: 0 2px 4px 0 $ob-filter-grey;
        -moz-box-shadow: 0 2px 4px 0 $ob-filter-grey;
        box-shadow: 0 2px 4px 0 $ob-filter-grey;
        position: absolute;
        top: 109px;
        right: 30px;
        z-index: 4;
        /*  arrow*/
        &:after, &:before{
            bottom: 100%;
            right: 46%;
            border: solid transparent;
            content: " ";
            height: 0;
            width: 0;
            position: absolute;
            pointer-events: none;
    }

    &:before {
        border-color: transparent;
        border-bottom-color: $ob-light-gray-1;
        border-width: 13px;
        margin-left: -13px;
    }

    &:after {
        border-color: rgba(255, 255, 255, 0);
        border-bottom-color: $ob-white-color;
        border-width: 12px;
        margin-left: -12px;
    }
    /* EOF arrow*/
    p{
        margin-bottom: 0;
    }

    h4 {
        color: $ob-brand-primary;
        font-size: 15px;
        font-weight: 600;
    }


    .mydb-filter__header {
        border-bottom: 1px solid $ob-light-gray-1;
        padding: 10px;
    }

    .my-filter__body-vendors {
        background: $ob-white-color;
        width: 398px;
        padding: 10px;
        height: 100px;
        overflow-y: auto;
        overflow-x: hidden;
    }

    .mydb-filter__body {
        background: $ob-white-color;
        width: 598px;
        padding: 15px;
        max-height: 300px;
        overflow-y: auto;
        overflow-x: hidden;
            .form-group{
            label{
                display: inline-block;
                max-width: 100%;
                margin-bottom: 5px;
                font-weight: 400;
            }

    }



    .mydb-filter__body--checkbox-holder {
        margin: 0 !important;
        p{
            color: #333;
            padding-bottom: 5px;
        }

    }

    .filter-by-tax-term {
        p{
            color: #333;
            padding-bottom: 5px;
        }

    }

    .mydb-filter__body--rate-holder {
        p{
            color: #333;
            padding-bottom: 5px;
        }

    }
    }


    .mydb-filter__footer {
        text-align: center;
        width: 598px;
        background: $ob-white-color;
        margin: 0;
        border-top: 1px solid $ob-light-gray-1;
        padding: 10px;
        button{
            margin: 0 5px;
        }

    }
    }
    .question-category-padd{
            padding-left: 15px !important;
    }
    .fdnsfilter--section{
        p{
            font-size: 12px;
            margin: 0 0 5px 0;
        }
    .checkbox-inline{
        margin-left:10px;
    }
    }
</style>


// WEBPACK FOOTER //
// src/components/ESSProfile/FDNS/FDNS-PopUp/FDNSFilters.vue